import * as React from "react";
import { type CSSProperties } from "react";
import { MagicEditButton } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

/**
 * Pin --primary to the brand navy (+ a light foreground) so the primary key —
 * the popover's send button, and the trigger's open-state fill — reads as the
 * rich navy in BOTH themes; the lib's shadcn --primary inverts to near-white
 * under .dark, which would wash it out (matches Button.demo's NAVY_PRIMARY).
 * `display:contents` scopes the var without changing the layout.
 */
const NAVY_PRIMARY = {
  "--primary": "212 72% 16%",
  "--primary-foreground": "0 0% 100%",
} as CSSProperties;

export function MagicEditButtonDemo() {
  const [title, setTitle] = React.useState("Intro to Calculus");

  return (
    <Section
      id="magic-edit-button"
      title="MagicEditButton"
      description="An inline edit-this-with-AI affordance: a pencil trigger that opens a small popover with a one-line instruction field and a send button. onEdit receives the trimmed instruction; the popover clears and closes on submit. Composes the Popover + Button + Input primitives, so Radix owns focus management (the field is focused on open) and the trigger's aria-expanded / aria-haspopup. Both controls inherit the Onyx 'offset key' press from Button: the ghost pencil trigger is a quiet flat key (notch + 1px press-down), the send button is the primary key (notch + travel block + 3px diagonal press). The trigger reads in primary while open."
    >
      <div className="contents" style={NAVY_PRIMARY}>
        <VariantBlock label="Inline beside a heading" caption="open the popover, type an instruction, and submit — onEdit echoes it into the title here">
          <div className="flex items-center gap-1.5">
            <h4 className="text-base font-semibold text-foreground">{title}</h4>
            <MagicEditButton
              sectionName="title"
              onEdit={(prompt) => setTitle(`${title} (edit: ${prompt})`)}
            />
          </div>
        </VariantBlock>

        <VariantBlock label="Disabled" caption="disabled blocks submit (e.g. while a previous edit is still applying)">
          <MagicEditButton sectionName="description" disabled onEdit={() => {}} />
        </VariantBlock>
      </div>
    </Section>
  );
}
